<template>
  <div>
    <BaseButton variant="primary" class="write-review-btn" @click="openModal">
      {{ $label('books.reviews.writeReview') }}
    </BaseButton>

    <BaseModal
      id="writeReview"
      :title="$label('books.reviews.writeReview')"
      :static-modal="staticModal"
    >
      <template #body>
        <AddReviewForm
          :book-slug="bookSlug"
          :book-uid="bookUid"
          :user-uid="loggedInUser.id"
          :set-loading-state="setLoadingState"
          :close-modal="closeModal"
        />
      </template>

      <template #footer>
        <BaseButton
          variant="primary"
          type="submit"
          form="book-review-form"
          :class="['confirm-btn', { loading: isLoading }]"
        >
          {{ $label('common.send') }}
        </BaseButton>
        <BaseButton variant="secondary" class="cancel-btn" @click="closeModal">
          {{ $label('common.cancel') }}
        </BaseButton>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import AddReviewForm from '~/components/reviews/AddReviewForm'
import BaseModal from '~/components/BaseModal'
import { useModal } from '~/composables/useModal'

export default {
  components: {
    BaseModal,
    AddReviewForm,
  },
  props: {
    bookSlug: {
      type: String,
      required: true,
    },
    bookUid: {
      type: String,
      required: true,
    },
    loggedInUser: {
      type: Object,
      required: true,
    },
    staticModal: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const modal = useModal('writeReview')

    return {
      modal,
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    setLoadingState(state) {
      this.isLoading = state
    },
    openModal() {
      this.modal.show()
    },
    closeModal() {
      this.modal.hide()
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-btn,
.cancel-btn {
  margin: 0;
}

@include media-breakpoint-down(sm) {
  .confirm-btn,
  .cancel-btn {
    width: 100%;
    flex: 0 0 48%;
  }
}

@include media-breakpoint-up(sm) {
  .confirm-btn {
    margin-right: 16px;
  }
}
</style>
